import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import BottomNav from "./components/BottomNav";
import Dashboard from "./pages/Dashboard";
import LogMeal from "./pages/LogMeal";
import History from "./pages/History";
import Insights from "./pages/Insights";

function Shell({ children }) {
  return (
    <div className="min-h-screen bg-cream">
      <div className="mx-auto w-full max-w-md min-h-screen bg-cream pb-44 relative">
        {children}
      </div>
      <BottomNav />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            color: "#2C302E",
            border: "1px solid #F4F1EA",
            borderRadius: "16px",
            boxShadow: "0 8px 30px rgba(44,48,46,0.08)",
            fontFamily: "Figtree, system-ui, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/log" element={<LogMeal />} />
            <Route path="/history" element={<History />} />
            <Route path="/insights" element={<Insights />} />
          </Routes>
        </Shell>
      </BrowserRouter>
    </div>
  );
}
